import { FormGroup } from '@angular/forms';
var TabGeneralComponent = /** @class */ (function () {
    function TabGeneralComponent() {
    }
    return TabGeneralComponent;
}());
export { TabGeneralComponent };
